import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_InputBlock = _resolveComponent("InputBlock")!

  return (_openBlock(), _createBlock(_component_InputBlock, {
    class: "dashboards-filter-item dashboards-filter-item_year",
    title: "Год",
    mode: "horizontal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_SelectMultiComponent, {
        modelValue: _ctx.localFilter.year,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFilter.year) = $event)),
        options: _ctx.getYearsOptions as never[],
        placeholder: "Выберите",
        classSelect: "multiselect--rectangular visible-clear",
        valueProp: "value",
        trackBy: "label",
        label: "label",
        canClear: false
      }, null, 8, ["modelValue", "options"])
    ]),
    _: 1
  }))
}